// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"8af34a7f","842":"103a2782","885":"7d7c314e"}[chunkId] + ".chunk.js";
};